import styled from "styled-components";
import {useParams} from "react-router-dom";
import {components, useGetResultsSearchParticulierBySearch} from "@mbj-front-monorepo/data-access";
import {useMemo, useState} from "react";
import {MbjLoading, MbjModal2, useModal} from "@mbj-front-monorepo/ui";
import {ResultParticulierCard} from "../components/ResultParticulierCard";
import {Compare} from "../../../../../../components/Comparateur/ComparaisonRef/Compare";

interface ResultsCvThequeCtrlProps{
    className?:string;
}

const ResultsCvThequeCtrl = (props:ResultsCvThequeCtrlProps)=>{
    const {id} = useParams();
    const [min, setMin] = useState(0);
    const [max, setMax] = useState(1);
    const {isShowing, toggle} = useModal();
    const ResultsQuery = useGetResultsSearchParticulierBySearch(id ? parseInt(id) : 0)
    const [resultPartCurr, setResultPartCurr] = useState<components["schemas"]["ResultsSearchParticulier-resultssearchparticulier.read_searchs.read_read.Member_read.UserMetier_read.Metier_read.particulier_statutresult.read"]|null>(null)
    const listResult = useMemo(()=>{
        if(!ResultsQuery.data){
            return [];
        } else {
            return ResultsQuery.data.filter(r=>{
                const CondMin = r.score && r.score >= min;
                const CondMax = r.score && r.score <= max;
                return CondMax && CondMin;
            })
        }
    }, [ResultsQuery.data, min, max])
    const ClickOnComparePart = (result:components["schemas"]["ResultsSearchParticulier-resultssearchparticulier.read_searchs.read_read.Member_read.UserMetier_read.Metier_read.particulier_statutresult.read"])=>{
        console.log('click !!');
        setResultPartCurr(result);
        toggle()
    }
    return (
        <div className={"result_emp "+props.className}>
            <div className={"wrap_results"}>
                {ResultsQuery.isLoading ? (<MbjLoading/>) : ResultsQuery.isError ? 'Error data' :
                    (
                        <div className={"wrap_result"}>
                            {listResult.map((item)=>(
                                <ResultParticulierCard key={`r${item.id}`} Search={item} clickToCompare={ClickOnComparePart}/>
                            ))}
                        </div>
                    )
                }
            </div>
            <MbjModal2 open={isShowing} closeMe={toggle} titre={"Comparaison"}>
                <Compare
                    SearchEmp={undefined}
                    SearchPart={resultPartCurr||undefined}
                    SearchRecl={undefined}
                />
            </MbjModal2>
        </div>
    )
}

const ResultsCvTheque = styled(ResultsCvThequeCtrl)`
  padding: 2% 1%;
  .wrap_result{
    display: flex;
    flex-wrap: wrap;
  }
`


export default ResultsCvTheque;
